export default "<h1 class=\"h2-style\">{{title}}</h1>\r\n\r\n<app-card [notStyled]=\"disableCardStyles\">\r\n    <ng-content></ng-content>\r\n</app-card>\r\n";